// utils/poolaLastRun.js
//
// One rule for "is there a last Poola worth showing", shared by the recap card on
// the Poola page's countdown screen and by the last-Poola page behind its link.
//
// The backend does not skip a finished run with no sales (reply brief
// 2026-10-04-poola-previous-run-on-current-BE-REPLY: skipping it would present an
// older run as "the last Poola"), so the app decides: a run with no number above
// 0 and no completed offer has nothing to say, and is treated as no run at all —
// no hollow card, and no finale page for it either.

/**
 * @param {object|null|undefined} run usePoolaDeal.previousRun
 * @returns {object|null} the same run, or null when it has nothing to show.
 */
export function lastRunWorthShowing(run) {
  if (!run) return null;
  const hasNumbers =
    Number(run.festival?.collectivePoolshareUsedCents) > 0 ||
    Number(run.festival?.collectivePoolcreditReturnedCents) > 0;
  const hasHighlights = Array.isArray(run.highlights) && run.highlights.length > 0;
  return hasNumbers || hasHighlights ? run : null;
}
